


export default function  FavMsgCatReducer( state={}, action){
    switch (action.type) {
       case "update_msg_Data" :
           return {...state,
            msg_cat_data:action.data
       
        }
        default:
           return{
               ...state
           }
   }
  
}